'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/audits/:auditId', null, {
            get: {method: 'GET'},
            actions: {url: 'api/audits/actions', method: 'GET'},
            tables: {url: 'api/audits/data-sets', method: 'GET'},
        });
    }];